import request from '@/utils/request'

let InfoApi = {

  /*同城服务列表*/
  list(data) {
    return request._post('/shop/plus.info.Index/index', data);
},

  /*同城服务分类列表*/
  getInfoType(data) {
    return request._post('/shop/plus.info.Index/getInfoType', data);
},
/*添加同城服务*/
add(data) {
    return request._post('/shop/plus.info.Index/add', data);
},
/*修改同城服务*/
edit(data) {
    return request._post('/shop/plus.info.Index/edit', data);
},
/*删除同城服务*/
del(data) {
    return request._post('/shop/plus.info.Index/del', data);
},
/*同城服务详情*/
detail(data) {
  return request._post('/shop/plus.info.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.info.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.info.Setting/getSetting', data, errorback);
    },
}
export default InfoApi;



// WEBPACK FOOTER //
// ./src/api/info.js